import type { MerchantGridColumn } from '../models/merchant';

/** Default page size for the Merchants grid. */
export const MERCHANTS_GRID_PAGE_SIZE = 15;

/**
 * Grid columns — `field` names match **PascalCase** JSON from the API.
 * Nested merchant name: `Merchant.Name` (Syncfusion dot path).
 */
export const MERCHANT_GRID_COLUMNS: readonly MerchantGridColumn[] = [
  { field: 'Id', headerText: 'ID', width: '200', isPrimaryKey: true, visible: false },
  { field: 'Email', headerText: 'Email', width: '220' },
  { field: 'FirstName', headerText: 'First name', width: '130' },
  { field: 'LastName', headerText: 'Last name', width: '130' },
  { field: 'Merchant.Name', headerText: 'Merchant', width: '180' },
  { field: 'Banned', headerText: 'Banned', width: '90', type: 'boolean' },
];

/** OData / grid primary key — must match `MerchantODataRow.Id`. */
export const MERCHANT_PRIMARY_KEY_FIELD = 'Id' as const;

/**
 * Primary key value from a grid row (PascalCase first, then camelCase fallback during API transitions).
 */
export function getMerchantRowId(row: Record<string, unknown>): string | undefined {
  const pk = MERCHANT_PRIMARY_KEY_FIELD;
  const raw = row[pk] ?? row['id'];
  if (raw === undefined || raw === null) {
    return undefined;
  }
  return String(raw);
}
